import api from '../httpClient';

export interface LinkedInStatus {
  configured: boolean;
  connected: boolean;
  expires_at: string | null;
  scopes: string[];
  missing_scopes?: string[];
}

export interface LinkedInInitiateResponse {
  authorization_url: string;
}

export interface LinkedInCertificatePostResponse {
  status: 'published';
  linkedin_post_urn: string;
  linkedin_url: string;
}

export const linkedin = {
  getStatus: () => api.get<LinkedInStatus>('/api/linkedin/status/'),
  disconnect: () => api.delete('/api/linkedin/connection/'),
  initiate: (returnTo: string) =>
    api.get<LinkedInInitiateResponse>('/api/auth/linkedin/initiate/', {
      params: { return_to: returnTo },
    }),
  postCertificate: (credentialId: string, commentary: string) =>
    api.post<LinkedInCertificatePostResponse>(
      `/api/certificates/${encodeURIComponent(credentialId)}/linkedin-post/`,
      { commentary },
    ),
};
